//store/modules/treasurers.js

import axios from './axios'
axios.defaults.withCredentials = true
axios.defaults.baseURL = process.env.VUE_APP_ROOT_API
const state = {
  fundTreasurers: {},
}
const getters = {
  fundTreasurers: (state) => state.fundTreasurers,
}
const actions = {
  async addCustodian({ commit }, custodian) {
    let response = await axios.post(
      '/service/fundraiser/addCustodianP',
      custodian,
    )
    await commit('setTR', response.data)
    return response.data
  },
  async getCustodians({ commit }, req) {
    let response = await axios.post('/service/fundraiser/custodiansP', req)
    await commit('setCustodians', response.data)
  },
  async deleteCustodian({ commit }, custodian) {
    let response = await axios.post(
      '/service/fundraiser/retire_detailsP',
      custodian,
    )
    await commit('setResponse', response.data)
    return response.data
  },
}
const mutations = {
  setTR(state, response) {
    state.TR = response
  },
  setCustodians(state, response) {
    state.fundTreasurers = response
  },
}
export default {
  state,
  getters,
  actions,
  mutations,
}
